module.exports = __webpack_public_path__ + "static/media/Bmwk-big-.6f1b8672.png";